import type {
  TIcon,
} from '../../types/icon.ts';

export interface INavigationMenuEntry {
  key: string,
  label: string,
  /** icon before the label, either an icon class such as `pi pi-code` or an SVG component */
  icon?: TIcon,
  count?: number,
  /** secondary text shown after the entry when it has no tag or count, e.g. a date */
  detail?: string,
  /** short label shown as tag after the entry, e.g. to mark it as new */
  tag?: string,
  /** renders the entry as link, so it can be opened in a new tab or copied, e.g. `#section-id` */
  href?: string,
}

export interface INavigationMenuGroup {
  label: string,
  count?: number,
  entries: INavigationMenuEntry[],
}

export type TNavigationMenuItem = INavigationMenuEntry | INavigationMenuGroup;

export function isNavigationMenuGroup(navigationMenuItem: TNavigationMenuItem): navigationMenuItem is INavigationMenuGroup {
  return 'entries' in navigationMenuItem;
}
